/* tslint:disable */

declare var Object: any;
export interface JobInterviewsInterface {
  "sfdcId"?: string;
  "CreatedById"?: string;
  "CurrencyIsoCode"?: string;
  "LastModifiedById"?: string;
  "RecordTypeId"?: string;
  "Name"?: string;
  "ts2__Account__c"?: string;
  "ts2__Client__c"?: string;
  "ts2extams__Action_Buttons__c"?: string;
  "ts2__Address__c"?: string;
  "ts2__Candidate__c"?: string;
  "ts2__Candidate_Debrief_Notes__c"?: string;
  "ts2__Candidate_Phone__c"?: string;
  "Candidate_Type__c"?: string;
  "ts2__Client_Interview_Notes__c"?: string;
  "ts2__Code__c"?: string;
  "ts2extams__Communication_Buttons__c"?: string;
  "ts2__Contact__c"?: string;
  "ts2__Client_Contact__c"?: string;
  "ts2__Contact_Email__c"?: string;
  "ts2__Contact_Phone__c"?: string;
  "ts2extams__Control_Buttons__c"?: string;
  "CreatedBy__c"?: string;
  "ts2__Date_Available__c"?: Date;
  "ts2__Email__c"?: string;
  "ts2__End_Date__c"?: Date;
  "ts2__Experience_Summary__c"?: string;
  "ts2__Face_to_Face__c"?: boolean;
  "ts2__HiringManager__c"?: string;
  "Hiring_Manager__c"?: string;
  "ts2__Interview_Location__c"?: string;
  "ts2__Job__c"?: string;
  "ts2__Job_Status__c"?: string;
  "LastModifiedBy__c"?: string;
  "ts2__Legacy_InterviewID__c"?: string;
  "ts2__Mobile__c"?: string;
  "ts2__Phone__c"?: boolean;
  "ts2__Phone_Number__c"?: string;
  "ts2__PrimaryRecruiter__c"?: string;
  "Primary_Recruiter__c"?: string;
  "ts2__Project__c"?: string;
  "Reason__c"?: string;
  "ts2__Reject_Detail__c"?: string;
  "ts2__Reject_Reason__c"?: string;
  "ts2__Related_Application__c"?: string;
  "ts2extams__Resume_Uploaded__c"?: string;
  "ts2__SecondaryRecruiter__c"?: string;
  "Secondary_Recruiter__c"?: string;
  "ts2__Start_Time__c"?: Date;
  "ts2__Status__c"?: string;
  "ts2extams__Substatus__c"?: string;
  "ts2__Type__c"?: string;
  "id"?: number;
  "createdAt"?: Date;
  "updatedAt"?: Date;
}

export class JobInterviews implements JobInterviewsInterface {
  "sfdcId": string;
  "CreatedById": string;
  "CurrencyIsoCode": string;
  "LastModifiedById": string;
  "RecordTypeId": string;
  "Name": string;
  "ts2__Account__c": string;
  "ts2__Client__c": string;
  "ts2extams__Action_Buttons__c": string;
  "ts2__Address__c": string;
  "ts2__Candidate__c": string;
  "ts2__Candidate_Debrief_Notes__c": string;
  "ts2__Candidate_Phone__c": string;
  "Candidate_Type__c": string;
  "ts2__Client_Interview_Notes__c": string;
  "ts2__Code__c": string;
  "ts2extams__Communication_Buttons__c": string;
  "ts2__Contact__c": string;
  "ts2__Client_Contact__c": string;
  "ts2__Contact_Email__c": string;
  "ts2__Contact_Phone__c": string;
  "ts2extams__Control_Buttons__c": string;
  "CreatedBy__c": string;
  "ts2__Date_Available__c": Date;
  "ts2__Email__c": string;
  "ts2__End_Date__c": Date;
  "ts2__Experience_Summary__c": string;
  "ts2__Face_to_Face__c": boolean;
  "ts2__HiringManager__c": string;
  "Hiring_Manager__c": string;
  "ts2__Interview_Location__c": string;
  "ts2__Job__c": string;
  "ts2__Job_Status__c": string;
  "LastModifiedBy__c": string;
  "ts2__Legacy_InterviewID__c": string;
  "ts2__Mobile__c": string;
  "ts2__Phone__c": boolean;
  "ts2__Phone_Number__c": string;
  "ts2__PrimaryRecruiter__c": string;
  "Primary_Recruiter__c": string;
  "ts2__Project__c": string;
  "Reason__c": string;
  "ts2__Reject_Detail__c": string;
  "ts2__Reject_Reason__c": string;
  "ts2__Related_Application__c": string;
  "ts2extams__Resume_Uploaded__c": string;
  "ts2__SecondaryRecruiter__c": string;
  "Secondary_Recruiter__c": string;
  "ts2__Start_Time__c": Date;
  "ts2__Status__c": string;
  "ts2extams__Substatus__c": string;
  "ts2__Type__c": string;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  constructor(data?: JobInterviewsInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `JobInterviews`.
   */
  public static getModelName() {
    return "JobInterviews";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of JobInterviews for dynamic purposes.
  **/
  public static factory(data: JobInterviewsInterface): JobInterviews{
    return new JobInterviews(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'JobInterviews',
      plural: 'JobInterviews',
      path: 'JobInterviews',
      idName: 'id',
      properties: {
        "sfdcId": {
          name: 'sfdcId',
          type: 'string'
        },
        "CreatedById": {
          name: 'CreatedById',
          type: 'string'
        },
        "CurrencyIsoCode": {
          name: 'CurrencyIsoCode',
          type: 'string'
        },
        "LastModifiedById": {
          name: 'LastModifiedById',
          type: 'string'
        },
        "RecordTypeId": {
          name: 'RecordTypeId',
          type: 'string'
        },
        "Name": {
          name: 'Name',
          type: 'string'
        },
        "ts2__Account__c": {
          name: 'ts2__Account__c',
          type: 'string'
        },
        "ts2__Client__c": {
          name: 'ts2__Client__c',
          type: 'string'
        },
        "ts2extams__Action_Buttons__c": {
          name: 'ts2extams__Action_Buttons__c',
          type: 'string'
        },
        "ts2__Address__c": {
          name: 'ts2__Address__c',
          type: 'string'
        },
        "ts2__Candidate__c": {
          name: 'ts2__Candidate__c',
          type: 'string'
        },
        "ts2__Candidate_Debrief_Notes__c": {
          name: 'ts2__Candidate_Debrief_Notes__c',
          type: 'string'
        },
        "ts2__Candidate_Phone__c": {
          name: 'ts2__Candidate_Phone__c',
          type: 'string'
        },
        "Candidate_Type__c": {
          name: 'Candidate_Type__c',
          type: 'string'
        },
        "ts2__Client_Interview_Notes__c": {
          name: 'ts2__Client_Interview_Notes__c',
          type: 'string'
        },
        "ts2__Code__c": {
          name: 'ts2__Code__c',
          type: 'string'
        },
        "ts2extams__Communication_Buttons__c": {
          name: 'ts2extams__Communication_Buttons__c',
          type: 'string'
        },
        "ts2__Contact__c": {
          name: 'ts2__Contact__c',
          type: 'string'
        },
        "ts2__Client_Contact__c": {
          name: 'ts2__Client_Contact__c',
          type: 'string'
        },
        "ts2__Contact_Email__c": {
          name: 'ts2__Contact_Email__c',
          type: 'string'
        },
        "ts2__Contact_Phone__c": {
          name: 'ts2__Contact_Phone__c',
          type: 'string'
        },
        "ts2extams__Control_Buttons__c": {
          name: 'ts2extams__Control_Buttons__c',
          type: 'string'
        },
        "CreatedBy__c": {
          name: 'CreatedBy__c',
          type: 'string'
        },
        "ts2__Date_Available__c": {
          name: 'ts2__Date_Available__c',
          type: 'Date'
        },
        "ts2__Email__c": {
          name: 'ts2__Email__c',
          type: 'string'
        },
        "ts2__End_Date__c": {
          name: 'ts2__End_Date__c',
          type: 'Date'
        },
        "ts2__Experience_Summary__c": {
          name: 'ts2__Experience_Summary__c',
          type: 'string'
        },
        "ts2__Face_to_Face__c": {
          name: 'ts2__Face_to_Face__c',
          type: 'boolean',
          default: false
        },
        "ts2__HiringManager__c": {
          name: 'ts2__HiringManager__c',
          type: 'string'
        },
        "Hiring_Manager__c": {
          name: 'Hiring_Manager__c',
          type: 'string'
        },
        "ts2__Interview_Location__c": {
          name: 'ts2__Interview_Location__c',
          type: 'string'
        },
        "ts2__Job__c": {
          name: 'ts2__Job__c',
          type: 'string'
        },
        "ts2__Job_Status__c": {
          name: 'ts2__Job_Status__c',
          type: 'string'
        },
        "LastModifiedBy__c": {
          name: 'LastModifiedBy__c',
          type: 'string'
        },
        "ts2__Legacy_InterviewID__c": {
          name: 'ts2__Legacy_InterviewID__c',
          type: 'string'
        },
        "ts2__Mobile__c": {
          name: 'ts2__Mobile__c',
          type: 'string'
        },
        "ts2__Phone__c": {
          name: 'ts2__Phone__c',
          type: 'boolean',
          default: false
        },
        "ts2__Phone_Number__c": {
          name: 'ts2__Phone_Number__c',
          type: 'string'
        },
        "ts2__PrimaryRecruiter__c": {
          name: 'ts2__PrimaryRecruiter__c',
          type: 'string'
        },
        "Primary_Recruiter__c": {
          name: 'Primary_Recruiter__c',
          type: 'string'
        },
        "ts2__Project__c": {
          name: 'ts2__Project__c',
          type: 'string'
        },
        "Reason__c": {
          name: 'Reason__c',
          type: 'string'
        },
        "ts2__Reject_Detail__c": {
          name: 'ts2__Reject_Detail__c',
          type: 'string'
        },
        "ts2__Reject_Reason__c": {
          name: 'ts2__Reject_Reason__c',
          type: 'string'
        },
        "ts2__Related_Application__c": {
          name: 'ts2__Related_Application__c',
          type: 'string'
        },
        "ts2extams__Resume_Uploaded__c": {
          name: 'ts2extams__Resume_Uploaded__c',
          type: 'string'
        },
        "ts2__SecondaryRecruiter__c": {
          name: 'ts2__SecondaryRecruiter__c',
          type: 'string'
        },
        "Secondary_Recruiter__c": {
          name: 'Secondary_Recruiter__c',
          type: 'string'
        },
        "ts2__Start_Time__c": {
          name: 'ts2__Start_Time__c',
          type: 'Date'
        },
        "ts2__Status__c": {
          name: 'ts2__Status__c',
          type: 'string'
        },
        "ts2extams__Substatus__c": {
          name: 'ts2extams__Substatus__c',
          type: 'string'
        },
        "ts2__Type__c": {
          name: 'ts2__Type__c',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
      }
    }
  }
}
